import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
  userInfo: any = {};
  userInfoSubscription: Subscription;
  copyRightYear = new Date().getFullYear();
  heading: any;
  clientDetails: any;
  assets_url = environment.assets_url;
  
  constructor(public router: Router, private route: ActivatedRoute, private commanSubscribeService: CommanSubscribeService) {
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
   
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
      route.url.subscribe(() => {
      this.heading = route.snapshot.children[0].data.heading;
      console.log('route-18',this.heading );
      });
      }
      });
   }

  ngOnInit(): void {
    this.clientDetails = environment.clientDetails;
  }

  redirectPage(page){    
    this.router.navigateByUrl(page);  
  }

  redirectTo() {
    this.router.navigateByUrl('/');
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }
}
